"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("./WidgetError");
/**
 * Error thrown when validation fails on object.
 */
class ValidationError extends WidgetError_1.default {
    constructor(message, validationErrors, referenceObject) {
        super(message);
        /**
         * The validation error message keyed by value key path.
         */
        this.validationErrors = {};
        this.validationErrors = validationErrors;
        this.referenceObject = referenceObject;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ValidationError.prototype);
        this.name = this.getCode();
    }
    /**
     * Gets the validation errors keyed by path.
     *
     * @return {*}
     */
    getValidationErrors() {
        return this.validationErrors;
    }
    /**
     * Gets the object that for which validation failed.
     *
     * @return {*}
     */
    getReferenceObject() {
        return this.referenceObject;
    }
}
/**
 * @inheritDoc
 */
ValidationError.code = "SW-VALIDATION";
exports.default = ValidationError;
